import { useAppSelector } from "app/store";

export const useUserNameSelector = () => {
  const userName = useAppSelector((state) => state.auth.user.alias);
  return { userName };
};

export const useFullNameSelector = () => {
  const fullName = useAppSelector((state) => state.auth.user.fullName);
  return { fullName };
};
